import './global.css'

import { Toaster } from '@/components/ui/toaster'
import { createRoot } from 'react-dom/client'
import { Toaster as Sonner } from '@/components/ui/sonner'
import { TooltipProvider } from '@/components/ui/tooltip'
import { QueryClient, QueryClientProvider } from '@tanstack/react-query'
import { BrowserRouter } from 'react-router-dom'
import { Provider as ReduxProvider } from 'react-redux'
import { WagmiProvider } from 'wagmi'
import { store } from '@/store/store'
import { SidebarUIProvider } from '@/context/SidebarUIContext'
import { AuthModalProvider } from '@/context/AuthModalContext'
import { DepositModalProvider } from '@/context/DepositModalContext'
import { LoaderOverlay } from '@/components/ui/loader-overlay'
import { LoaderProvider } from '@/context/LoaderContext'
import { SearchModalProvider } from '@/context/SearchModalContext'
import { PhantomWalletProvider } from '@/context/PhantomWalletProvider'
import { wagmiConfig } from '@/lib/wagmi-config'
import { AppRoutes } from '@/routes'
import { ReferralTracking } from '@/components/auth/ReferralTracking'

const queryClient = new QueryClient()

const App = () => (
	<ReduxProvider store={store}>
		<WagmiProvider config={wagmiConfig}>
			<PhantomWalletProvider>
				<QueryClientProvider client={queryClient}>
					<TooltipProvider>
						<Toaster />
						<Sonner />
						<BrowserRouter>
							<LoaderProvider>
								<LoaderOverlay />
								<AuthModalProvider>
									<DepositModalProvider>
										<SearchModalProvider>
											<SidebarUIProvider>
												<ReferralTracking />
												<AppRoutes />
											</SidebarUIProvider>
										</SearchModalProvider>
									</DepositModalProvider>
								</AuthModalProvider>
							</LoaderProvider>
						</BrowserRouter>
					</TooltipProvider>
				</QueryClientProvider>
			</PhantomWalletProvider>
		</WagmiProvider>
	</ReduxProvider>
)

createRoot(document.getElementById('root')!).render(<App />)
